import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useConditionalPalettes } from 'reporting-visualizations/hooks/useConditionalPalettes';
import { Select } from 'foundations-components/transitional/components/Select';
import ConditionalFormattingPaletteSquatch from './ConditionalFormattingPaletteSquatch';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_PALETTE = 'WhiteToOrange';
const PaletteItemComponent = ({
  option
}) => /*#__PURE__*/_jsx(Button, {
  use: "unstyled",
  "data-option-value": option.value,
  "data-option-text": option.text,
  children: /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexGrow: 1,
    rowGap: "200",
    children: [/*#__PURE__*/_jsx(ConditionalFormattingPaletteSquatch, {
      minColor: option.minColor,
      maxColor: option.maxColor,
      midColor: option.midColor,
      paletteId: option.paletteId
    }), /*#__PURE__*/_jsx(Text, {
      marginInlineStart: "200",
      children: option.text
    })]
  })
});
const ValueComponent = props => /*#__PURE__*/_jsx(PaletteItemComponent, Object.assign({}, props));
const OptionComponent = props => /*#__PURE__*/_jsx(PaletteItemComponent, Object.assign({}, props));
const ConditionalFormattingColorSelect = ({
  selectedPalette,
  onChange
}) => {
  const conditionalPalettes = useConditionalPalettes();
  const options = Object.values(conditionalPalettes).map(palette => {
    return {
      value: palette.id,
      text: I18n.text(palette.label || palette.id),
      palette: palette.id,
      minColor: palette.colors.minColor,
      maxColor: palette.colors.maxColor,
      midColor: palette.colors.midColor
    };
  });
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.conditional-formatting.color-palette"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      options: options,
      "data-test-id": "conditional-formatting-color-palette",
      value: selectedPalette || DEFAULT_PALETTE,
      onChange: ({
        target: {
          value
        }
      }) => {
        onChange(value);
      },
      valueComponent: ValueComponent,
      optionComponent: OptionComponent
    })
  });
};
export default ConditionalFormattingColorSelect;